import { IImpersonateState } from '../interfaces/iimpersonate-state';


export const IMPERSONATE_STATE: IImpersonateState = {
  isActive: false,
  backup: null,
  pictureBackup: null
};
